import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, memo, useContext, useMemo } from "react";
const DiscussionPermissionsProviderContext = /*#__PURE__*/ createContext(undefined);
export const DiscussionPermissionsProvider = /*#__PURE__*/ memo((param)=>{
    let { children, permissions } = param;
    const value = useMemo(()=>({
            permissions
        }), [
        permissions
    ]);
    return /*#__PURE__*/ _jsx(DiscussionPermissionsProviderContext.Provider, {
        value: value,
        children: children
    });
});
DiscussionPermissionsProvider.displayName = "DiscussionPermissionsProvider";
export function useDiscussionPermissions() {
    const context = useContext(DiscussionPermissionsProviderContext);
    if (!context) {
        throw "DiscussionPermissionsProviderContext used outside of DiscussionPermissionsProvider";
    }
    return context;
}
